import { render, staticRenderFns } from "./pay-welfare.vue?vue&type=template&id=6ba47ac7&scoped=true&"
import script from "./pay-welfare.vue?vue&type=script&lang=js&"
export * from "./pay-welfare.vue?vue&type=script&lang=js&"
import style0 from "./pay-welfare.vue?vue&type=style&index=0&id=6ba47ac7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba47ac7",
  null
  
)

export default component.exports